// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/location_sets_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementLocationSetsData } from "./constants";
import type { EngagementLocationSetsDataParams, EngagementLocationSetsDataResult } from "./types";

export const getDataTableEngagementLocationSetsData = reactQueryTableFetcherAdapter(
  engagementLocationSetsData,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementLocationSetsDataParams
  ): Promise<EngagementLocationSetsDataResult> => {
    return fetch(
      "/engagement/location_sets_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
